import React, { useEffect, useMemo, useState } from 'react';
import { Box } from '@mui/material';
import PageHeader from 'src/shared/components/layout/PageHeader';
import GroupIcon from '@mui/icons-material/Group';
import { Tooltip, Fab } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import AddIcon from '@mui/icons-material/Add';
import DeliveryRateDetails from './components/DeliveryRateDetails';
import PndApi from '../../../../utils/pnd/PndRestApi';
import DeliveryRateModal from '../AddOrUpdate/components/DeliveryRateModal';
import { LinearProgress, SnackbarContent } from '@mui/material';
import { showNotification } from 'src/shared/components/Notification';
import { ERROR_MESSAGES } from 'src/utils/pnd/PndConstants';

const DeliveryRateDetailsIndex = () => {
  useEffect(() => {
    getAllDeliveryAreaRateDetails();
  }, [])

  const [reactTableData, setReactTableData] = useState([]);
  const [temp, setTempData] = useState("");
  const [viewDetailPopup, setViewDetailPopup] = useState(false);
  const [isTitle, setTitle] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isNoRecordFound, setNoRecordFound] = useState(false);

  const getAllDeliveryAreaRateDetails = async () => {
    try {
      setLoading(true);
      const response = await PndApi.GetAllDeliveryAreaRateDetails();
      if (response.status === 200 && response.data.status === 200) {
        setReactTableData({ tableHeaderData: columns, tableRowsData: response.data.data });
      } else if (response?.data?.status && response?.data?.status === 204) {
        setNoRecordFound(true);
      } else {
        {
          showNotification(
            "theme-light",
            "ltr",
            `SuccessCode: ${response.data.status}`,
            `Message:${response.data?.message}`,
          );
          return;
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
      showNotification(
        "theme-light",
        "ltr",
        `SuccessCode: 500`,
        ERROR_MESSAGES.tryCatchError,
      );
    } finally {
      setLoading(false);
    }
  };


  const columns = useMemo(
    () => [
      {
        Header: '#',
        accessor: (row, i) => i + 1, // Or just use Cell below for more control
        disableGlobalFilter: true,
        disableSortBy: true,
        width: 15,
        Cell: ({ row }) => row.index + 1, // <-- This sets the serial number based on row index
      },

      {
        Header: 'Area Name',
        accessor: 'areaName',
        disableGlobalFilter: false,
      },

      {
        Header: 'Area Code',
        accessor: 'areaCode',
        disableGlobalFilter: false,
      },
      {
        Header: 'Rate (AED)',
        accessor: 'rate',
        disableGlobalFilter: false,
        Cell: ({ value }) => String(value), // Convert the value to a string
      },

      {
        Header: 'Action',
        accessor: 'edit',
        disableSortBy: true,
        Cell: row => (
          <div className="icon-style" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "flex-start" }}>
            <Tooltip title="Click here to Edit details">
              <EditIcon style={{ cursor: "pointer" }} onClick={() => edit(row.row.original)} />
            </Tooltip>
          </div>
        ),
      },
    ],
    [],
  );

  const edit = async (event) => {
    if (event.deliveryAreaId) {
      setTempData(event);
      setViewDetailPopup(true);
      setTitle("Edit - Delivery Rate Details");
    }
  };
  // Function to open Add New Rate modal
  const Add = () => {
    setViewDetailPopup(true);
    setTitle("Add Delivery Rate");
  };


  return (
      <Box sx={{ p: 3, backgroundColor: '#f8fafc', minHeight: '100vh' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
          <PageHeader
            icon={<GroupIcon fontSize="large" />}
            title="Delivery Rate Details"
            subtitle="View and manage delivery zone rates."
            gradient="linear-gradient(135deg, #0284c7 0%, #0369a1 100%)"
          />
          <Fab
            size="large"
            color="primary"
            aria-label="add"
            sx={{ backgroundColor: '#32CA73', color: 'white' }}
            onClick={Add}
          >
            <AddIcon />
          </Fab>
        </Box>
      {loading && <LinearProgress color="primary" sx={{ mb: 2 }} />}
      <DeliveryRateDetails reactTableData={reactTableData} isNoRecordFound={isNoRecordFound} onAdd={Add} />
      {isNoRecordFound && <SnackbarContent message={'No Record Found'} />}
      {viewDetailPopup && (
        <DeliveryRateModal
          modalShow={viewDetailPopup}
          setModalShow={setViewDetailPopup}
          data={temp}
          isTitle={isTitle}
        />
      )}
    </Box>
  );
};

export default DeliveryRateDetailsIndex;